function getHashCode(str: string) {
  return (
    str
      .split('')
      // eslint-disable-next-line no-bitwise
      .reduce((prevHash, currVal) => ((prevHash << 5) - prevHash + currVal.charCodeAt(0)) | 0, 0)
  );
}

export const getHashedIndex = (str: string, len: number) => Math.abs(getHashCode(str) % len);
